/* eslint-disable monsterverse-rules/no-uuid-literals */
export const BlockAssets = {
  Yellow: "f9db3df3-a4f7-4edd-a22e-f530e9dc12ad",
};
